import { startInactiveSpan } from "@sentry/nextjs";

// OpenTelemetry SpanStatusCode values (stable spec, not re-exported by
// @sentry/nextjs's public API): 0 = UNSET, 1 = OK, 2 = ERROR.
export const SpanStatus = {
  Ok: { code: 1 } as const,
  UnknownError: { code: 2, message: "unknown_error" } as const,
};

export const SentryHelpers = {
  startTransaction: (options: Parameters<typeof startInactiveSpan>[0]) =>
    startInactiveSpan(options),
};
